import React, {useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { CustomerRewards,CardPerso} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { useParams } from "react-router-dom";

const useInit = () => {
    const t =useTranslate()
    const [loadingSearchClient,setLoadingSearchClient]=useState(false)

    const [clientFideliteInfo,setClientFideliteInfo]=useState(false) 

    const getFideliteInfo = async (clientId) => {
        setLoadingSearchClient(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/fidelite/get_fidelite_client/"+clientId
        ).then((response) => {
            setLoadingSearchClient(false)
            setClientFideliteInfo(response.data)
            
        }).catch((error) => {
            setLoadingSearchClient(false)
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    return [loadingSearchClient,getFideliteInfo,clientFideliteInfo]
}

const SearchHistoriqueFidelite = (props) => {
    const t =useTranslate()
    const { posid } = useParams();
    const [loadingSearchClient,getFideliteInfo,clientFideliteInfo]=useInit()

    // Quand le client change on charge la fidelite
    useEffect(function () {
        if (props.clientId !== false) getFideliteInfo(props.clientId);
    }, [props.clientId])

    return(<>
        <CardPerso>
            {loadingSearchClient ?
                <div className="d-flex justify-content-center"><span className="spinner-border spinner-border-sm"></span></div>
            :
                ((!clientFideliteInfo) ? 
                    <div className="text-center fw-bold">{t('customerLoyalty')}</div> 
                :
                    <>
                        <div className="text-center fw-bold mb-2"> 
                            <span className="fs-3">{t('accumulatedPoints')+' : '}</span>
                            <span className="fs-2">{(clientFideliteInfo) ? clientFideliteInfo.total_point_fidelite_client : ''}</span>
                        </div>
                        <CustomerRewards 
                            clientFideliteInfo={clientFideliteInfo}
                            posid={posid}
                            from='histoClient'
                        />
                    </>   
                )
            }
        </CardPerso>
        </>
    )
    
}

export default SearchHistoriqueFidelite;